import { combineReducers } from 'redux';
import list from './List/reducer';
import userList from './UserLabelsList/reducer';
import create from './Create/reducer';
import edit from './Edit/reducer';

const labelsReducer = combineReducers({
  list,
  create,
  edit,
  userList,
});

export default labelsReducer;
